/**
 * contractBackground.ts — a contract record names its background text `background`.
 *
 * The forecast server's result wire still says `contract.context` (its wire is not
 * chatboard's to change), so a contract read off it is mapped here, where it enters the
 * record, rather than read as a fallback everywhere later. The server maps its own entry
 * points the same way (server/lib/contractBackground.js).
 */

/**
 * `contract` with its background under `background`. A `context` key is folded in and
 * dropped: a non-empty `background` wins, else `context` is the background. Anything that
 * is not a contract object, or carries no `context`, is returned as is.
 */
export function withBackground<T>(contract: T): T {
  if (!contract || typeof contract !== "object" || Array.isArray(contract)) return contract;
  if (!Object.prototype.hasOwnProperty.call(contract, "context")) return contract;
  const { context, ...rest } = contract as Record<string, unknown>;
  return (rest.background ? rest : { ...rest, background: context }) as T;
}
